"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var sendBoxValue = _ref.sendBoxValue;
  return sendBoxValue;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJzZW5kQm94VmFsdWUiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlbGVjdG9ycy9zZW5kQm94VmFsdWUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBSZWR1eFN0YXRlIH0gZnJvbSAnLi4vdHlwZXMvaW50ZXJuYWwvUmVkdXhTdGF0ZSc7XG5cbmV4cG9ydCBkZWZhdWx0ICh7IHNlbmRCb3hWYWx1ZSB9OiBSZWR1eFN0YXRlKTogc3RyaW5nID0+IHNlbmRCb3hWYWx1ZTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O2VBRWUsU0FBQUEsU0FBQUMsSUFBQTtFQUFBLElBQUdDLFlBQVksR0FBQUQsSUFBQSxDQUFaQyxZQUFZO0VBQUEsT0FBMkJBLFlBQVk7QUFBQTtBQUFBQyxPQUFBLGNBQUFILFFBQUEifQ==